import React, { useEffect, useState } from "react";
import { Checkbox } from "@mui/material";
import { useHistory } from "react-router-dom";
// import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useParams } from "react-router";
import {
  softDeleteLedger,
  createCOA,
  getERPPullRequests,
} from "../../Services/ApiHandler";
import swal from "sweetalert";
import {
  getBCTbRows,
  getDeletedLedgersRows,
  setIsDeletedLedgerModal,
  setSelectedFlatRows,
  splitMappingChecked,
} from "../../../redux/actions/BookClosure/actionBookClosure";
import DeletedLedgerModal from "./DeletedLedgerModal";
import FilterLedger from "./FilterLedgerModal";
import switchModeSvg from "../../../assets/switchMode.svg";
import filterSvg from "../../../assets/filter.svg";
import trashSvg from "../../../assets/trash.svg";
import adjustmentSvg from "../../../assets/adjustment.svg";
import SwitchModeModal from "./SwitchModeModal";
import COAModal from "./Style/COAModal";

import buttoncss from "../../../myfin_v2/css/button.module.css";
import bookclosuretbcss from "../../../myfin_v2/css/bookclosuretb.module.css";
import { ReactComponent as FilterIcon } from "../../../myfin_v2/assets/icons/filter.svg";
import { ReactComponent as LeftIcon } from "../../../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as SearchIcon } from "../../../myfin_v2/assets/icons/search.svg";
import { ReactComponent as DeleteIcon } from "../../../myfin_v2/assets/icons/delete_icon_primary.svg";
import { ReactComponent as CloseGreyIcon } from "../../../myfin_v2/assets/icons/close_grey.svg";
import { ReactComponent as RecycleBinIcon } from "../../../myfin_v2/assets/icons/recycleBin.svg";
import Dropdown from "../../../myfin_v2/elements/Dropdown";
import ToggleButton from "../../../myfin_v2/elements/ToggleButton";
import { Button } from "../../../myfin_v2/elements/Button";
import Table from "../../../myfin_v2/elements/Table";
import temp_viewtb from "../../../myfin_v2/data/temp_viewtb.json";
import PageWithSubTables from "../../../myfin_v2/components/bookclosure/TempTables";
import UploadTbV2 from "../../Pages/UploadTbV2";
import AddTBModal from "../../../myfin_v2/components/bookclosure/AddTBModal";
import UploadTBModal from "../../../myfin_v2/components/bookclosure/UploadTBModal";
import PullTBfromERPModal from "../../../myfin_v2/components/bookclosure/PullTBfromERPModal";
import CreateCOAModal from "../../../myfin_v2/components/bookclosure/COAModal";
import RestoreLedgerModal from "../../../myfin_v2/components/bookclosure/RestoreLedgerModal";

const TbcHeader = ({ lineItems, currentMode, setFilteredLineItems, allLineItems, searchText, setSearchText, deletedLedgers, splitMapping=true }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { bookClosureTbId, workspaceId, companyId } = useParams();
  const [filterShow, setFilterShow] = useState(false);
  const [object, setObject] = useState({});
  const [filterEnable, setFilterEnable] = useState(false);
  const [showSwitchMode, setSwitchMode] = useState(false);
  const [openModal, setOperModal] = useState(false);
  const [mode, setMode] = useState(currentMode);
  const [displayModal, setDisplayModal] = useState(false);
  const [addTBModal, setAddTBModal] = useState(false);
  const [uploadTBModal, setUploadTBModal] = useState(false);
  const [pullTBfromERPModal, setPullTBfromERPModal] = useState(false);
  const [erpConnections, setErpConnections] = useState([]);
  const [createCOAModal, setCreateCOAModal] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [restoreLedgerModal, setRestoreLedgerModal] = useState(false);

  const { selectedFlatRows } = useSelector(
    (initialState) => initialState.BookClosureTbcReducer
  );

  function handleSelect(mode) {
    setMode(mode);
    if (mode === "1") {
      history.push(
        `/conventional-mode-tbc/${bookClosureTbId}/${workspaceId}/${companyId}`
      );
    }
    if (mode === "2") {
      history.push(`/tbc/${bookClosureTbId}/${workspaceId}/${companyId}`);
    }
  }

  const HandleDeleteLedgers = () => {
    if (selectedFlatRows.length <= 0) {
      toast.warning("Please Select Any Ledger Foe Delete.");
      return;
    }

    if (selectedFlatRows.length > 1) {
      toast.warning("Multiple delete ledgers not allowed..");
      return;
    }

    softDeleteLedger(bookClosureTbId, {
      ledgerID: selectedFlatRows[0]._id,
    })
      .then((response) => {
        toast.success("Ledger deleted successfully.");
        dispatch(getBCTbRows(bookClosureTbId));
        dispatch(setSelectedFlatRows([]));
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Soft delete ledger failed",
          "error"
        );
      });
  };

  const handleSave = (coaName) => {
    const data = {
      name: coaName,
      bookClosureTBID: bookClosureTbId,
    };
    createCOA(data)
      .then((response) => {
        toast.success("COA Created Successfully.");
        // setOperModal(false);
        setCreateCOAModal(false);
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Create COA failed",
          "error"
        );
      });
  };
  const uploadTb = () => {
    setDisplayModal(true);
    setAddTBModal(true);
  };
  const handleClose = () => {
    setDisplayModal(false);
  };

  const addTBFromERP = () => {
    // getERPPullRequests
    const get_params = { companyId: companyId, status: "C", reqtype: "PULL" };
    getERPPullRequests(get_params)
      .then((response) => {
        setErpConnections(response.data.erpRequests);
      })
      .catch((error) => {
        // swal("Error", `Error in fetching ERP Pull Connections: ${error.response?.data?.error}`, 'error');
      });
    setPullTBfromERPModal(true);
  };
  const handleAddTbModals = (flag) => {
    if (flag === "close") {
      setDisplayModal(false);
      setAddTBModal(false);
      setUploadTBModal(false);
      setPullTBfromERPModal(false);
    }
  };

  const openSearch = () => {
    setShowSearch(true);
  };

  const closeSearch = () => {
    setExpanded(false);
    setTimeout(() => setShowSearch(false), 600);
    setSearchText("");
  };

  // useEffect(() => {
  //   if (showSearch) {
  //     const timeout = setTimeout(() => setExpanded(true), 15);
  //     return () => clearTimeout(timeout);
  //   } else {
  //     setExpanded(false);
  //   }
  // }, [showSearch]);

  return (
    <>
      <div className="bk-closure-tb-header">
        <div className="bk-closure-tb-header-left">
          <LeftIcon
            height={15}
            width={15}
            className="clickable"
            onClick={() => history.push(`/bookclosure/${workspaceId}`)}
          />
          {/* <SearchIcon /> */}
          {/* {!showSearch && (
            <SearchIcon onClick={openSearch} style={{cursor:"pointer"}} />
          )}

          {showSearch && (
            
            <div className={`${bookclosuretbcss.searchBox} ${expanded ? bookclosuretbcss.expanded : ""}`}>
              <SearchIcon className={bookclosuretbcss.searchInside}/>
              <input
                type="text"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search ledger name/code"
                className={bookclosuretbcss.searchInput}
              />
              <CloseGreyIcon
                style={{cursor:"pointer"}}
                onClick={closeSearch}
              />
            </div>
          )} */}

          <div style={{ position: "relative", display: "inline-block" }}>

          <SearchIcon onClick={openSearch} style={{ cursor: "pointer" }} />

          {showSearch && (
            <div className={bookclosuretbcss.searchOverlay}>
              <SearchIcon className={bookclosuretbcss.searchInside} />
              <input
                type="text"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search ledger name/code"
                className={bookclosuretbcss.searchInput}
                autoFocus
              />
              <CloseGreyIcon style={{ cursor: "pointer" }} onClick={closeSearch} />
            </div>
          )}
        </div>

          <FilterIcon
            onClick={() => {
              setFilterShow(!filterShow);
            }}
          />
          <DeleteIcon onClick={HandleDeleteLedgers} />
          {splitMapping && (
            <span>
              <ToggleButton
                label="Split Mapping"
                onToggle={(e) => {
                  dispatch(splitMappingChecked(e));
                }}
              />
            </span>
          )}
        </div>
        <div className="button-group ml-10">
          <button
            className={`${buttoncss.custom_btn} ${
              mode === "2" ? buttoncss.primary : buttoncss.secondary
            }`}
            style={{
              borderRadius: "8.18px 0px 0px 8.18px",
              ...(mode !== "2" && { background: "#f5f5f5" }),
            }}
            onClick={() => {
              handleSelect("2");
            }}
          >
            Template mode
          </button>
          <button
            className={`${buttoncss.custom_btn} ${
              mode === "1" ? buttoncss.primary : buttoncss.secondary
            }`}
            style={{
              borderRadius: "0 8.18px 8.18px 0",
              ...(mode !== "1" && { background: "#f5f5f5" }),
            }}
            onClick={() => {
              handleSelect("1");
            }}
          >
            Conventional mode
          </button>
        </div>
        <div className="bk-closure-tb-header-right">
          <RecycleBinIcon
            className={`${bookclosuretbcss.clickable} mr-1`}
            onClick={() => {
              setDisplayModal(true);
              setRestoreLedgerModal(true);
            }} width={22} height={25} style={{ "place-self": "center" }} 
          />
          <Button
            btnColor={buttoncss.secondary}
            class_={buttoncss.greyBg}
            label="Upload TB"
            onClick={uploadTb}
          />
          <Button
            btnColor={buttoncss.secondary}
            class_={buttoncss.greyBg}
            label="Save CoA"
            onClick={() => {
              // setOperModal(true)
              setCreateCOAModal(true);
            }}
          />
          <Button
            btnColor={buttoncss.primary}
            label="Confirm Grouping"
            onClick={() => history.push(`/bookclosure/${workspaceId}`)}
          />
        </div>
      </div>

      <div>
        <COAModal
          isOpen={openModal}
          onClose={() => setOperModal(false)}
          SaveCOA={handleSave}
          setOperModal={setOperModal}
        />
        {createCOAModal && (
          <CreateCOAModal
            setCreateCOAModal={setCreateCOAModal}
            SaveCOA={handleSave}
          />
        )}
        {showSwitchMode ? (
          <SwitchModeModal
            close={setSwitchMode}
            name="Choose a Mapping Mode"
            currentMode={currentMode}
            bookClosureTbId={bookClosureTbId}
            workspaceId={workspaceId}
          />
        ) : null}
      </div>

      <DeletedLedgerModal />
      <FilterLedger
        show={filterShow}
        setObject={setObject}
        setFilterShow={setFilterShow}
        filterHandler={setFilterEnable}
        setFilteredLineItems={setFilteredLineItems}
        allLineItems={allLineItems}
        lineItems={lineItems}
      />
      {addTBModal && displayModal && (
        <AddTBModal
          setUploadTBModal={setUploadTBModal}
          handleClose={handleClose}
          setAddTBModal={setAddTBModal}
          setPullTBfromERPModal={addTBFromERP}
          isUpdateModal={true}
        />
      )}
      {uploadTBModal && displayModal && (
        <UploadTbV2
          workspaceId={workspaceId}
          companyId={companyId}
          setUploadTBModal={setUploadTBModal}
          setAddTBModal={setAddTBModal}
          setDisplayModal={setDisplayModal}
        />
      )}

      {pullTBfromERPModal && displayModal && (
        <PullTBfromERPModal
          handleClose={handleClose}
          setAddTBModal={setAddTBModal}
          setPullTBfromERPModal={setPullTBfromERPModal}
          erpConnections={erpConnections}
          companyId={companyId}
          bookClosureId={bookClosureTbId}
          handleAddTbModals={handleAddTbModals}
        />
      )}

      {restoreLedgerModal && displayModal && (
        <RestoreLedgerModal
          handleClose={handleClose}
          setRestoreLedgerModal={setRestoreLedgerModal}
          deletedLedgers={deletedLedgers}
        />
    )}
    </>
  );
};

export default TbcHeader;
